// taskApi.js
import { url } from "../../static/env";

export function getReportingServices() {
  return fetch(url + '/get_reporting_services', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => {
      return data.reporting_services || [];
    })
    .catch(error => {
      console.error('Error fetching reporting services:', error);
      throw error;
    });
}

export function getReportingFiles(reporting_id) {
  return fetch(url + `/get_reporting_files?reporting_id=${reporting_id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => {
      return data.files || [];
    })
    .catch(error => {
      console.error('Error fetching reporting files:', error);
      throw error;
    });
}

export function getTasks(user_id, options = {}) {
  console.log('url', url)
  const body = { user_id };
  if (options.company_id) body.company_id = options.company_id;
  return fetch(url + '/tasks', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then(response => response.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error('Error fetching tasks:', error);
      throw error;
    });
}

export function getTasksFast(user_id, options = {}) {
  const body = { user_id };
  if (options.company_id) body.company_id = options.company_id;
  return fetch(url + '/tasks-fast', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error fetching tasks-fast:', error);
      throw error;
    });
}

/** Непросмотренные «Готовые» задачи: { unread_count, by_company_id }. */
export function getTasksUnreadCount(user_id) {
  return fetch(url + '/tasks-unread-count', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user_id }),
  })
    .then((response) => response.json())
    .then((data) => ({
      unread_count: Number(data?.unread_count) || 0,
      by_company_id:
        data?.by_company_id && typeof data.by_company_id === 'object'
          ? data.by_company_id
          : {},
    }))
    .catch((error) => {
      console.error('Error fetching tasks unread count:', error);
      throw error;
    });
}

/** Клиент открыл «Готовые» — пометить готовые задачи просмотренными. */
export function markTasksViewed(user_id, options = {}) {
  const body = { user_id };
  if (options.company_id) body.company_id = options.company_id;
  return fetch(url + '/tasks-mark-viewed', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error marking tasks viewed:', error);
      throw error;
    });
}

export function createTask(user_id, title, text, { timeout, urgency, is_task_report, reporting_services, company_id }, callback, onFinally) {
  fetch(url + '/create-task', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id,
      company_id: company_id || undefined,
      title,
      text,
      timeout,
      urgency,
      is_task_report,
      reporting_services
    }),
  })
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok || data?.error || data?.code === 'buh_service_suspended') {
        console.log('createTask', data);
        if (typeof callback === 'function') callback(data);
        return;
      }
      return Promise.resolve(callback(data));
    })
    .catch(error => {
      console.error('Error creating task:', error);
    })
    .finally(() => {
      if (typeof onFinally === 'function') onFinally();
    });
}

export function createTaskWithFiles(user_id, title, text, { timeout, urgency, company_id }, files, callback, onFinally) {
  console.log('createTaskWithFiles', files, { user_id, company_id });
  let formData = new FormData();

  if (Array.isArray(files) && files.length > 0) {
    files.forEach((file) => {
      formData.append("files[]", file);
    });
  }

  formData.append('user_id', user_id);
  if (company_id) formData.append('company_id', String(company_id));
  formData.append('title', title || '');
  formData.append('text', text || '');
  formData.append('timeout', timeout);
  formData.append('urgency', urgency);

  console.log('Uploading task to:', url);

  fetch(url + '/create-task-files', {
    method: 'POST',
    body: formData
  })
    .then(async (response) => {
      try {
        const data = await response.json();
        console.log('Upload task response:', data);
        if (callback) await Promise.resolve(callback(data));
      } catch (err) {
        console.log('Non-JSON response:', response);
      }
    })
    .catch((error) => {
      console.error('Error uploading task with files:', error);
    })
    .finally(() => {
      if (typeof onFinally === 'function') onFinally();
    });
}


export function updateTask(task_id, title, text, { timeout, urgency }, callback) {
  fetch(url + '/update-task', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: task_id,
      title,
      text,
      timeout,
      urgency
    }),
  })
    .then(response => response.json())
    .then(data => {
      callback(data);
    })
    .catch(error => {
      console.error('Error updating task:', error);
    });
}

export function updateTaskWithFiles(task_id, title, text, { timeout, urgency }, files, callback) {
  console.log('updateTaskWithFiles', files);
  console.log('updateTaskWithFiles timeout', timeout);
  let formData = new FormData();

  if (Array.isArray(files) && files.length > 0) {
    files.forEach((file) => {
      formData.append("files[]", file);
    });
  }

  formData.append('id', task_id);
  formData.append('title', title || '');
  formData.append('text', text || '');
  formData.append('timeout', timeout);
  formData.append('urgency', urgency);

  console.log('Updating task with files to:', url);

  fetch(url + '/update-task-files', {
    method: 'POST',
    body: formData
  })
    .then(async (response) => {
      try {
        const data = await response.json();
        console.log('Update task with files response:', data);
        if (callback) callback(data);
      } catch (err) {
        console.log('Non-JSON response:', response);
      }
    })
    .catch((error) => {
      console.error('Error updating task with files:', error.message);
    });
}
